import React from 'react';
import { useQuery } from '../../hooks/useQuery';
import './SearchList.css';

interface SearchList {
  label?: string;
  link?: string;
  onClick: (url: any) => any;
  setKeyword: React.Dispatch<React.SetStateAction<string>>;
}

const SearchList = ({ label, link, onClick, setKeyword }: SearchList) => {
  const query = useQuery();

  const handleOnClick = (link: string | undefined) => {
    if (query.get('isSubApp')) {
      const msg = {
        target: '9assetApp',
        type: 'mobileSearch-goto',
        value: link,
      };

      console.log('mobileSearch-goto:', msg);
      window.parent.postMessage(msg, '*');
    } else {
      return link;
    }
  };

  if (query.get('isSubApp')) {
    return (
      <>
        <div
          className="px-12 py-1.5 w-full no-underline text-black hover:underline hover:bg-gray-200"
          // target="#"
          onClick={() => {
            onClick(link);
            setKeyword('');
            handleOnClick(link);
          }}>
          {label}
        </div>
      </>
    );
  } else {
    return (
      <>
        <a
          href={link}
          className="px-12 py-1.5 w-full no-underline text-black hover:underline hover:bg-gray-200"
          target="_blank"
          rel="noreferrer"
          onClick={() => {
            onClick(link);
            setKeyword('');
          }}>
          {label}
        </a>
      </>
    );
  }
};

export default SearchList;
